<template>
    <div class="project-statuses">
        
        <div class="list" v-if="statuses && statusTypes">

            <div class="project-status" v-for="status in statuses" :key="status.uuid">
                <div class="name">
                    {{ status.name }}
                </div>
                <div class="type">
                    <b style="font-weight:600;">Vælg type:</b>
                    &nbsp;&nbsp;
                    <select v-model="status.type.uuid" @change="update(status, $event)">
                        <option :value="null">- Ingen type -</option>
                        <option :value="statusType.uuid" v-for="statusType in statusTypes" :key="statusType.uuid">
                            {{ statusType.name }}
                        </option>
                    </select>
                </div>
            </div>

        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .list {

        .project-status {
            background: $color--white;
            padding: $padding--main;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: $margin--main;
            border-radius: $borderradius--main;
            box-shadow: $boxshadow--creative;

            .name {
                font-weight: 600;
            }

            .type {

                select {
                    padding: 4px 10px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    cursor: pointer;
                    border-radius: $borderradius--main;
                }
            }
        }
    }

</style>

<script>
import * as projectStatusService from '@/services/projectStatusService'

export default {
    data () {
        return {
            statuses: null,
            statusTypes: null
        }
    },
    created () {
        this.getData()
        this.getStatusTypes()
    },
    methods: {
        getData () {
            projectStatusService.findAll({}, (response) => {
                this.statuses = response.data
            }, (err) => {
                console.log(err)
            })
        },
        getStatusTypes () {
            projectStatusService.statusTypes({}, (response) => {
                this.statusTypes = response.data
            }, (err) => {
                console.log(err)
            })
        },
        update (status, event) {
            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.')
                return
            }
            let body = {
                status_uuid: event.target.value
            }
            projectStatusService.update(status.uuid, body, (response) => {
                this.$toastr('success', 'Opgavestatusen blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// projectStatuses.vue?159d0b0b